import {Platform, StyleSheet} from 'react-native';
import Typography from '../../../../shared/constants/Typography';
import { hp } from '@shared/utils/dimensions';

export const createPaginationStyles = (theme: any) =>
  StyleSheet.create({
    rightSection: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap10,
    },
    customContainerStyles: {
      flexShrink: 0,
      height: Typography.height.height44,
    },
    paginationButtons: {
      backgroundColor: theme.paginationButtonBG,
      borderColor: theme.listPaginationBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      //paddingVertical: Typography.padding.padding12,
      paddingHorizontal: Typography.padding.padding26,
      borderRadius: Typography.radius.radius8,
      height: Typography.height.height44,
    },
    paginationButtonsText: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      color: theme.paginationButtonText,
      fontFamily: Typography.fontFamily.inter,
    },
    contentWrapper: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      alignItems: Typography.textAlign.centerAlign,
      paddingTop: Typography.padding.padding16,
      flexShrink: 1,
    },
    leftSection: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap12,
      flexShrink: 1,
    },
    textRow: {
      flexShrink: 1,
    },
    /** Outer Text wrapper for the mixed-style summary line.
     *  flexShrink:1 lets it compress inside the flex row so numberOfLines=1
     *  triggers the ellipsis when space is tight. */
    summaryTextOuter: {
      flexShrink: 1,
    },
    hiddenTestNode: {
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden',
      opacity: 0,
      color: theme.listFooterTextColor,
      // WCAG 1.4.3: visibility:hidden excludes elements from WCAG automated
      // contrast checks entirely (unlike opacity:0 which still participates).
      // aria-hidden=true is also set in JSX on web for the same reason.
      ...(Platform.OS === 'web' ? {visibility: 'hidden' as const} : {}),
    },
    text: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      color: theme.listFooterTextColor,
      fontFamily: Typography.fontFamily.inter,
    },
    darkText: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.listFooterTextColor,
      fontFamily: Typography.fontFamily.inter,
    },
    customTextStyles: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      //color: theme.listFooterCountText,
      fontFamily: Typography.fontFamily.inter,
    },
    pageButton: {
      backgroundColor: theme.paginationButtonBG,
      borderRadius: Typography.radius.radius8,
      borderColor: theme.listPaginationBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
      //paddingVertical: 12,
      paddingHorizontal: 18,
      justifyContent: Typography.textAlign.centerAlign,
      height: Typography.height.height44,
    },
    activePageButton: {
      backgroundColor: theme.selectedPagination,
      borderColor: theme.selectedPagination,
      borderRadius: Typography.radius.radius8,
    },
    pageText: {
      color: theme.paginationButtonText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },
    activePageText: {
      color: theme.selectedPaginationText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },
    ellipsis: {
      color: theme.dots,
      fontWeight: Typography.fontWeight.semiBold,
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
    },
    paginationDots: {
      //paddingVertical: 12,
      paddingHorizontal: Typography.padding.padding18,
      justifyContent: Typography.textAlign.centerAlign,
      height: Typography.height.height40,
      backgroundColor: theme.paginationButtonBG,
      borderRadius: Typography.radius.radius8
    },
  });
